import {
  SlMenu
} from "./chunk.UHA22HSA.js";

// src/components/menu/menu.ts
var menu_default = SlMenu;
SlMenu.define("sl-menu");

export {
  menu_default
};
